import Phaser from 'phaser'
import MovingObjectEditor from '../editor/movingObjectEditor'

export const PATH_TYPE_LINE = 0
export const PATH_TYPE_CIRCLE = 1

export default class MovingObjectComponent {
  constructor (scene, actor, args, showCorners) {
    this.scene = scene
    this.actor = actor
    this.showCorners = showCorners
    this.waitForBounce = false

    this.speed = args.speed || 200
    this.currentSpeed = this.speed
    this.p0 = args.p0 || new Phaser.Math.Vector2(this.actor.image.x, this.actor.image.y)
    this.p1 = args.p1 || new Phaser.Math.Vector2(this.actor.image.x, this.actor.image.y)
    this.curviness = args.curviness || 0
    this.interpolation = args.interpolation || 0
    this.pathType = args.pathType || 0
    this.delay = args.delay || 0

    this.paused = false
    this.pathIndex = 0
    this.t = this.delay
    this.pathVector = new Phaser.Math.Vector2()

    this.slowStart = args.slowStart || false

    // if (this.pathType === PATH_TYPE_LINE) {
    this.setPathLine(this.p0, this.p1)
    // } else if (this.pathType === PATH_TYPE_CIRCLE) {
    //   this.setPathCircle(this.radius)
    // }

    // DEBUG:
    // this.target = this.scene.add.image(this.p0.x, this.p0.y, 'white')
    // this.target.setTint(0xFF0000)
    // this.target.setScale(20, 20)
    // this.target.setDepth(50)
  }

  enable () {
    this.actor.addEditableProperty('speed', (value) => { this.setSpeed(value) }, () => { return this.speed })
    this.actor.addEditableProperty('curviness', (value) => { this.curviness = value; this.refreshPath(this.p0, this.p1) }, () => { return this.curviness })
    this.actor.addEditableProperty('interpolation', (value) => { this.interpolation = value; this.refreshPath(this.p0, this.p1) }, () => { return this.interpolation })
    this.actor.addEditableProperty('delay', (value) => { this.delay = value; this.setT(0); this.refreshPath(this.p0, this.p1) }, () => { return this.delay })
    this.actor.addEditableProperty('slowStart', (value) => { this.slowStart = value }, () => { return this.slowStart })

    this.actor.addHiddenProperty('p0', () => { return this.p0 })
    this.actor.addHiddenProperty('p1', () => { return this.p1 })
    this.actor.addHiddenProperty('pathType', () => { return this.pathType })

    this.movingObjectEditor = new MovingObjectEditor(this.scene, this, this.actor)
    this.actor.handles.push(this.movingObjectEditor)

    var wasX = this.actor.image.x
    var wasY = this.actor.image.y
    // this.startEdit()
    this.movingObjectEditor.setPos(wasX, wasY)
    this.movingObjectEditor.refreshHandlerPositions()

    this.borderA.setVisible(true)
    this.borderB.setVisible(true)
    this.line.setVisible(true)

    this.bAcenter.setVisible(true)
    this.bBcenter.setVisible(true)

    if (this.showCorners) {
      this.bAcornerLT.setVisible(true)
      this.bAcornerLB.setVisible(true)
      this.bAcornerRB.setVisible(true)
      this.bAcornerRT.setVisible(true)

      this.bBcornerLT.setVisible(true)
      this.bBcornerLB.setVisible(true)
      this.bBcornerRB.setVisible(true)
      this.bBcornerRT.setVisible(true)
    }
  }

  disable () {
    this.actor.removeProperty('speed')
    this.actor.removeProperty('curviness')
    this.actor.removeProperty('interpolation')
    this.actor.removeProperty('delay')

    this.actor.removeProperty('p0')
    this.actor.removeProperty('p1')
    this.actor.removeProperty('pathType')

    this.actor.removeEditor(this.movingObjectEditor)
    this.startEdit()
    this.movingObjectEditor.delete()

    this.borderA.setVisible(false)
    this.borderB.setVisible(false)
    this.bAcenter.setVisible(false)
    this.bBcenter.setVisible(false)
    this.line.setVisible(false)
    this.bAcornerLT.setVisible(false)
    this.bAcornerLB.setVisible(false)
    this.bAcornerRB.setVisible(false)
    this.bAcornerRT.setVisible(false)
    this.bBcornerLT.setVisible(false)
    this.bBcornerLB.setVisible(false)
    this.bBcornerRB.setVisible(false)
    this.bBcornerRT.setVisible(false)
  }

  setSpeed (speed) {
    this.speed = speed
    this.refreshPath(this.p0, this.p1)
  }

  refreshLine (p0, p1) {
    this.line.x = p0.x + (p1.x - p0.x) / 2
    this.line.y = p0.y + (p1.y - p0.y) / 2
    this.line.setDisplaySize(10, Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2)))

    var diff = new Phaser.Math.Vector2(p1.x, p1.y)
    diff.subtract(p0)
    var angle = diff.angle()
    this.line.setRotation(angle + (Math.PI * 0.5))
  }

  refreshPath (p0, p1) {
    this.p0 = p0
    this.p1 = p1
    this.pC1 = new Phaser.Math.Vector2(this.p0.x, this.p0.y + this.curviness)
    this.pC2 = new Phaser.Math.Vector2(this.p1.x, this.p1.y + this.curviness)

    this.path = new Phaser.Curves.Line(this.p0, this.p1)
    if (this.interpolation === 1) {
      this.path = new Phaser.Curves.CubicBezier(this.p0, this.pC1, this.pC2, this.p1)
    }
    this.pathDistance = Math.sqrt(Math.pow(p1.x - p0.x, 2) + Math.pow(p1.y - p0.y, 2))
    this.pathSpeed = this.pathDistance / this.speed
    this.path.getPoint(this.pathIndex, this.pathVector)

    this.actor.image.setPosition(this.p0.x, this.p0.y)

    this.borderA.x = p0.x
    this.borderA.y = p0.y

    this.borderB.x = p1.x
    this.borderB.y = p1.y

    this.borderA.setTexture(this.actor.image.texture.key, this.actor.image.frame.name)
    this.borderB.setTexture(this.actor.image.texture.key, this.actor.image.frame.name)
    this.borderA.setScale(this.actor.image.scaleX, this.actor.image.scaleY)
    this.borderB.setScale(this.actor.image.scaleX, this.actor.image.scaleY)

    this.bAcenter.x = p0.x
    this.bAcenter.y = p0.y

    this.bBcenter.x = p1.x
    this.bBcenter.y = p1.y

    this.bAcornerLT.x = p0.x - this.actor.image.scaleX * 0.5 + 25
    this.bAcornerLT.y = p0.y - this.actor.image.scaleY * 0.5 + 25
    this.bAcornerRT.x = p0.x + this.actor.image.scaleX * 0.5 - 25
    this.bAcornerRT.y = p0.y - this.actor.image.scaleY * 0.5 + 25
    this.bAcornerLB.x = p0.x - this.actor.image.scaleX * 0.5 + 25
    this.bAcornerLB.y = p0.y + this.actor.image.scaleY * 0.5 - 25
    this.bAcornerRB.x = p0.x + this.actor.image.scaleX * 0.5 - 25
    this.bAcornerRB.y = p0.y + this.actor.image.scaleY * 0.5 - 25

    this.bBcornerLT.x = p1.x - this.actor.image.scaleX * 0.5 + 25
    this.bBcornerLT.y = p1.y - this.actor.image.scaleY * 0.5 + 25
    this.bBcornerRT.x = p1.x + this.actor.image.scaleX * 0.5 - 25
    this.bBcornerRT.y = p1.y - this.actor.image.scaleY * 0.5 + 25
    this.bBcornerLB.x = p1.x - this.actor.image.scaleX * 0.5 + 25
    this.bBcornerLB.y = p1.y + this.actor.image.scaleY * 0.5 - 25
    this.bBcornerRB.x = p1.x + this.actor.image.scaleX * 0.5 - 25
    this.bBcornerRB.y = p1.y + this.actor.image.scaleY * 0.5 - 25

    // this.borderA.setScale(0.5)// 40, 40)
    // this.borderB.setScale(0.5)// 40, 40)

    this.refreshLine(new Phaser.Math.Vector2(this.borderA.x, this.borderA.y), new Phaser.Math.Vector2(this.borderB.x, this.borderB.y))
  }

  setPathLine (p0, p1) {
    this.borderA = this.scene.add.image(0, 0, 'white')// 'images', 'circle')
    this.borderB = this.scene.add.image(0, 0, 'white')// 'images', 'circle')

    this.borderA.setDepth(1)
    this.borderB.setDepth(1)

    this.borderA.setAlpha(0.2)
    this.borderB.setAlpha(0.2)

    this.borderA.setVisible(false)
    this.borderB.setVisible(false)

    this.bAcenter = this.scene.add.image(0, 0, 'images', 'circle')
    this.bBcenter = this.scene.add.image(0, 0, 'images', 'circle')
    this.bAcenter.setScale(0.5)
    this.bBcenter.setScale(0.5)

    this.bAcenter.setVisible(false)
    this.bBcenter.setVisible(false)

    this.bAcornerLT = this.scene.add.image(0, 0, 'images', 'corner')
    this.bAcornerLB = this.scene.add.image(0, 0, 'images', 'corner')
    this.bAcornerRT = this.scene.add.image(0, 0, 'images', 'corner')
    this.bAcornerRB = this.scene.add.image(0, 0, 'images', 'corner')
    this.bAcornerRB.setAngle(90)
    this.bAcornerLB.setAngle(180)
    this.bAcornerLT.setAngle(270)
    this.bAcornerLT.setVisible(false)
    this.bAcornerLB.setVisible(false)
    this.bAcornerRT.setVisible(false)
    this.bAcornerRB.setVisible(false)

    this.bBcornerLT = this.scene.add.image(0, 0, 'images', 'corner')
    this.bBcornerLB = this.scene.add.image(0, 0, 'images', 'corner')
    this.bBcornerRT = this.scene.add.image(0, 0, 'images', 'corner')
    this.bBcornerRB = this.scene.add.image(0, 0, 'images', 'corner')
    this.bBcornerRB.setAngle(90)
    this.bBcornerLB.setAngle(180)
    this.bBcornerLT.setAngle(270)
    this.bBcornerLT.setVisible(false)
    this.bBcornerLB.setVisible(false)
    this.bBcornerRT.setVisible(false)
    this.bBcornerRB.setVisible(false)

    this.line = this.scene.add.image(0, 0, 'images', 'finish')
    this.line.setOrigin(0.5, 0.5)
    this.line.setDepth(1)
    this.line.setVisible(false)

    this.refreshPath(p0, p1)
  }

  //   setPathCircle (radius) {
  //     // this.pathType = PATH_TYPE_CIRCLE
  //     this.path = new Phaser.Curves.Ellipse(this.image.x, this.image.y, radius, radius)
  //     this.pathDistance = radius * Math.PI * 2
  //     this.pathSpeed = this.pathDistance / this.speed
  //     this.path.getPoint(this.pathIndex, this.pathVector)
  //     this.image.setPosition(this.pathVector.x, this.pathVector.y)
  //   }

  easeOutCubic (x) {
    return 1 - Math.pow(1 - x, 3)
  }

  easeOutQuadratic (x) {
    return 1 - (1 - x) * (1 - x)
  }

  easeInOutSine (x) {
    return -(Math.cos(Math.PI * x) - 1) / 2
  }

  update (time, delta) {
    if (this.paused) {
      return
    }

    this.currentSpeed = Math.min(this.speed, this.currentSpeed + (delta * 0.001 * 25))
    this.pathSpeed = this.pathDistance / this.currentSpeed
    this.t += (delta * 0.001) / this.pathSpeed

    if (this.pathType === PATH_TYPE_LINE) {
      this.t %= 2
      this.pathIndex = this.t > 1 ? 1 - (this.t - 1) : this.t

      if (this.interpolation === 1) {
        this.pathIndex = this.easeInOutSine(this.pathIndex)
      } else if (this.interpolation === 2) {
        this.pathIndex = this.easeOutQuadratic(this.pathIndex)
      }
    } else if (this.pathType === PATH_TYPE_CIRCLE) {
      this.t = Phaser.Math.Wrap(this.t, 0, 1)
      this.pathIndex = this.t
    }

    this.path.getPoint(this.pathIndex, this.pathVector)
    var velocity = new Phaser.Math.Vector2(this.pathVector.x - this.actor.image.x, this.pathVector.y - this.actor.image.y)
    // velocity.x *= delta * 0.001
    // velocity.y *= delta * 0.001
    this.actor.image.setVelocity(velocity.x, velocity.y)

    // DEBUG
    // this.target.setPosition(this.pathVector.x, this.pathVector.y)
  }

  startEdit () {
    this.pause()

    this.setT(0)
    this.movingObjectEditor.refreshHandlerPositions()
  }

  setT (value) {
    this.t = (value + this.delay) % 2
    this.pathIndex = this.t
    this.path.getPoint(this.pathIndex, this.pathVector)

    this.actor.image.x = this.p0.x
    this.actor.image.y = this.p0.y

    this.actor.onEdit()

    // this.actor.image.x = this.pathVector.x
    // this.actor.image.y = this.pathVector.y
  }

  pause () {
    this.paused = true
    this.actor.image.setVelocity(0, 0)
  }

  unpause (onBounce = false) {
    if (this.waitForBounce && !onBounce) {
      return
    }

    this.paused = false
    if (this.slowStart) {
      this.currentSpeed = 0.75 * this.speed
    }
  }

  onBounce () {
    if (this.waitForBounce) {
      this.unpause(true)
    }
  }

  delete () {
    this.borderA.destroy()
    this.borderB.destroy()
    this.line.destroy()

    this.bAcenter.destroy()
    this.bBcenter.destroy()

    this.bAcornerLT.destroy()
    this.bAcornerLB.destroy()
    this.bAcornerRT.destroy()
    this.bAcornerRB.destroy()
    this.bBcornerLT.destroy()
    this.bBcornerLB.destroy()
    this.bBcornerRT.destroy()
    this.bBcornerRB.destroy()
  }
}
